import React from 'react';
import { useTranslation } from 'react-i18next';
import { TypeOffre } from '../../../hooks';
import { Police, Typography, Variant } from '../../../styles';

interface TitreExemplesVariationsProps {
    cssClasse: string;
}

export const TitreExemplesVariations: React.FC<
    TitreExemplesVariationsProps
> = ({ cssClasse }) => {
    const [t] = useTranslation(['DetailsOffreModal']);

    return (
        <Typography className={cssClasse} variant={Variant.h3}>
            {t('titreSectionExemplesVariations')}
        </Typography>
    );
};

interface TextExemplesVariationsProps {
    typeOffre: TypeOffre;
}

export const TextExemplesVariations: React.FC<TextExemplesVariationsProps> = ({
    typeOffre
}) => {
    const [t] = useTranslation(['DetailsOffreModal']);

    switch (typeOffre) {
        case TypeOffre.CINQ_ANS_VARIABLE_REDUIT:
            return (
                <>
                    <Typography variant={Variant.p}>
                        {t('exemplesEcartGaranti', {
                            ecart1: '-0',
                            ecart2: '70'
                        })}
                    </Typography>

                    <Typography variant={Variant.p} police={Police.bold}>
                        {t('exemplesVariation', { variation: 1 })}
                    </Typography>
                    <Typography variant={Variant.p}>
                        {t('exemplesTauxPreferentiel', {
                            taux1: '3',
                            taux2: '45'
                        })}
                    </Typography>
                    <Typography variant={Variant.p}>
                        {t('exemplesTauxPersonnalise', {
                            taux1: '2',
                            taux2: '75'
                        })}
                    </Typography>

                    <Typography variant={Variant.p} police={Police.bold}>
                        {t('exemplesVariation', { variation: 2 })}
                    </Typography>
                    <Typography variant={Variant.p}>
                        {t('exemplesTauxPreferentiel', {
                            taux1: '2',
                            taux2: '95'
                        })}
                    </Typography>
                    <Typography variant={Variant.p}>
                        {t('exemplesTauxPersonnalise', {
                            taux1: '2',
                            taux2: '25'
                        })}
                    </Typography>

                    <Typography variant={Variant.p} police={Police.bold}>
                        {t('exemplesVariation', { variation: 3 })}
                    </Typography>
                    <Typography variant={Variant.p}>
                        {t('exemplesTauxPreferentiel', {
                            taux1: '3',
                            taux2: '75'
                        })}
                    </Typography>
                    <Typography variant={Variant.p}>
                        {t('exemplesTauxPersonnalise', {
                            taux1: '3',
                            taux2: '05'
                        })}
                    </Typography>
                </>
            );
        case TypeOffre.CINQ_ANS_VARIABLE_PROTEGE:
            return (
                <>
                    <Typography variant={Variant.p}>
                        {t('exemplesEcartGaranti', {
                            ecart1: '-0',
                            ecart2: '60'
                        })}
                    </Typography>
                    <Typography variant={Variant.p}>
                        {t('exemplesTauxMaximum', {
                            taux1: '3',
                            taux2: '29'
                        })}
                    </Typography>
                    <Typography variant={Variant.p} police={Police.bold}>
                        {t('exemplesVariation', { variation: 1 })}
                    </Typography>
                    <Typography variant={Variant.p}>
                        {t('exemplesTauxPreferentiel', {
                            taux1: '2',
                            taux2: '45'
                        })}
                    </Typography>
                    <Typography variant={Variant.p}>
                        {t('exemplesTauxPersonnalise', {
                            taux1: '1',
                            taux2: '85'
                        })}
                    </Typography>
                    <Typography variant={Variant.p} police={Police.bold}>
                        {t('exemplesVariation', { variation: 2 })}
                    </Typography>
                    <Typography variant={Variant.p}>
                        {t('exemplesTauxPreferentiel', {
                            taux1: '3',
                            taux2: '45'
                        })}
                    </Typography>
                    <Typography variant={Variant.p}>
                        {t('exemplesTauxPersonnalise', {
                            taux1: '2',
                            taux2: '85'
                        })}
                    </Typography>
                    <Typography variant={Variant.p} police={Police.bold}>
                        {t('exemplesVariation', { variation: 3 })}
                    </Typography>
                    <Typography variant={Variant.p}>
                        {t('exemplesTauxPreferentiel', {
                            taux1: '4',
                            taux2: '45'
                        })}
                    </Typography>
                    <Typography variant={Variant.p}>
                        <s>
                            {t('exemplesTauxPersonnalise', {
                                taux1: '3',
                                taux2: '85'
                            })}
                        </s>
                    </Typography>
                    <Typography variant={Variant.p}>
                        {t('exemplesVotreTaux', {
                            taux1: '3',
                            taux2: '29'
                        })}
                    </Typography>
                </>
            );
        case TypeOffre.CINQ_ANS_REVISABLE_FERME:
            return (
                <>
                    <Typography variant={Variant.p}>
                        {t('exemplesEcartGaranti', {
                            ecart1: '-0',
                            ecart2: '20'
                        })}
                    </Typography>

                    <Typography variant={Variant.p} police={Police.bold}>
                        {t('exemplesAnnee', { annee: 1 })}
                    </Typography>
                    <Typography variant={Variant.p}>
                        {t('exemplesAnnee1')}
                    </Typography>
                    <Typography variant={Variant.p}>
                        {t('exemplesAnneeVotreTaux', {
                            taux1: '4',
                            taux2: '79'
                        })}
                    </Typography>

                    <Typography variant={Variant.p} police={Police.bold}>
                        {t('exemplesAnnee', { annee: 2 })}
                    </Typography>
                    <Typography variant={Variant.p}>
                        {t('exemplesAnnee2')}
                    </Typography>
                    <Typography variant={Variant.p}>
                        {t('exemplesAnneeVotreTaux', {
                            taux1: '4',
                            taux2: '79'
                        })}
                    </Typography>

                    <Typography variant={Variant.p} police={Police.bold}>
                        {t('exemplesAnnee', { annee: 3 })}
                    </Typography>
                    <Typography variant={Variant.p}>
                        {t('exemplesAnnee3')}
                    </Typography>
                    <Typography variant={Variant.p}>
                        {t('exemplesAnneeVotreTaux', {
                            taux1: '5',
                            taux2: '04'
                        })}
                    </Typography>

                    <Typography variant={Variant.p} police={Police.bold}>
                        {t('exemplesAnnee', { annee: 4 })}
                    </Typography>
                    <Typography variant={Variant.p}>
                        {t('exemplesAnnee4')}
                    </Typography>
                    <Typography variant={Variant.p}>
                        {t('exemplesAnneeVotreTaux', {
                            taux1: '4',
                            taux2: '54'
                        })}
                    </Typography>

                    <Typography variant={Variant.p} police={Police.bold}>
                        {t('exemplesAnnee', { annee: 5 })}
                    </Typography>
                    <Typography variant={Variant.p}>
                        {t('exemplesAnnee5')}
                    </Typography>
                    <Typography variant={Variant.p}>
                        {t('exemplesAnneeVotreTaux', {
                            taux1: '4',
                            taux2: '29'
                        })}
                    </Typography>
                </>
            );
        default:
            return <></>;
    }
};
